exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@-webkit-keyframes scroll {\n  from {\n    -webkit-transform: translateX(0);\n            transform: translateX(0); }\n  to {\n    -webkit-transform: translateX(-100%);\n            transform: translateX(-100%); } }\n\n@keyframes scroll {\n  from {\n    -webkit-transform: translateX(0);\n            transform: translateX(0); }\n  to {\n    -webkit-transform: translateX(-100%);\n            transform: translateX(-100%); } }\n\n.cfz-popup .content {\n  overflow: hidden; }\n\n.cfz-popup .image-container {\n  overflow-x: scroll; }\n\n.cfz-popup .image-scroll {\n  height: 80vh;\n  width: auto;\n  max-width: none; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./src/modules/Popup/popup.scss
// module id = 1026
// module chunks = 4